"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hashData = void 0;
var crypto_1 = require("@harmoniclabs/crypto");
var Data_1 = require("./Data.js");
var toCbor_1 = require("./toCbor.js");
function hashData(data) {
    if (!(0, Data_1.isData)(data))
        throw new Error("hashData only works with Data");
    return (0, crypto_1.blake2b_256)((0, toCbor_1.dataToCbor)(data).toBuffer());
}
exports.hashData = hashData;
